import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Navbar from './Navbar';
import CookieBanner from './CookieBanner';
import { useAnalytics } from '../hooks/useAnalytics';

function Layout({ children }) {
  // Inizializza analytics per tracciare pageview automaticamente
  useAnalytics();
  
  return (
    <>
      <Navbar />
      <Header />
      {/* Contenuto dinamico della pagina */}
      {children}
      <Footer />
      <CookieBanner />
    </>
  );
}

export default Layout;
